import FloorplateView from './floorplate-view'

export default FloorplateView
